<div class="placeholder-page-container">
  <h2 *scText="rendering.fields.header"> </h2> <br/>
  <h3>select the carrier <a href="learn/mobile/byod/compatibility/carrier">here</a></h3>    
  <h3>Find more information about <a href="learn/mobile/byod/compatibility/sim">sim configuration</a></h3>
</div>